import { render, staticRenderFns } from "./TrainingCard.vue?vue&type=template&id=6ad9b9f9&scoped=true&"
import script from "./TrainingCard.vue?vue&type=script&lang=js&"
export * from "./TrainingCard.vue?vue&type=script&lang=js&"
import style0 from "./TrainingCard.vue?vue&type=style&index=0&id=6ad9b9f9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad9b9f9",
  null
  
)

export default component.exports